@if(useCustomTemplate) {
<div
  class="h-100 position-relative pointer-events-none webkit-tap-highlight-color-transparent"
  (click)="copyContent()"
>
  <div class="position-absolute-fill" [ngStyle]="contentStyle">
    <mat-icon class="mr-2" [ngStyle]="leftIconStyle" *ngIf="leftIcon" svgIcon="{{ leftIcon }}"></mat-icon>
    <div [ngStyle]="textAlignment" [innerHTML]="textContentTemplate | safeHtml"></div>
    <mat-icon [ngStyle]="rightIconStyle" class="ml-2" *ngIf="rightIcon" svgIcon="{{ rightIcon }}"></mat-icon>
  </div>
</div>
} @else {
<div class="h-100">
  <finx-button
    [buttonStyle]="!isAllowedGlobalStyling ? contentStyle : {}"
    [labeltext]="textContentTemplate ?? ''"
    class="pointer-events-none d-flex"
    [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100'"
    [isAllowedGlobalStyling]="isAllowedGlobalStyling"
    [style.height]="'100%'"
    (click)="copyContent()"
  ></finx-button>
</div>

}
